<div class="messages-main-container">
  <div class="header">
    <div class="header-content">
      <div class="header-text">
        <h2>{{ 'MESSAGES.TITLE' | translate }}</h2>
        <p class="subtitle">{{ 'MESSAGES.HOME' | translate }}</p>
      </div>
      <div class="header-filter">
        <app-notification-filter [notifications]="messages" storageKey="messages_filter_unread">
        </app-notification-filter>
      </div>
    </div>
  </div>

  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="loadMessages()">{{ 'GLOBAL.RETRY' | translate }}</button>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">
    <!-- Messages List -->
    <div class="items-grid">
      <div class="item-card" *ngFor="let message of filteredMessages" [class.unread]="!message.isRead"
        (click)="onMessageClick(message.notificationID)" role="button" tabindex="0"
        (keydown.enter)="onMessageClick(message.notificationID)"
        (keydown.space)="onMessageClick(message.notificationID)">

        <div class="card-header">
          <h3 class="item-title">{{ message.title }}</h3>
          <span class="item-date">{{ formatDate(message.created) }}</span>
        </div>

        <div class="card-body">
          <p class="item-preview">{{ getPreviewText(message.body) }}</p>
        </div>

        <div class="card-footer">
          <span class="read-status" [class.unread]="!message.isRead">
            {{ getReadStatusText(message.isRead) | translate}}
          </span>
          <span class="view-details">{{ 'GLOBAL.DETAIL' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="no-items" *ngIf="filteredMessages.length === 0">
      <div class="no-items-card">
        <div class="no-items-icon">
          <mat-icon>mail_outline</mat-icon>
        </div>
        <h3>{{ 'MESSAGES.NOMESSAGES' | translate }}</h3>
        <p>{{ 'MESSAGES.NOMESSAGESTOSHOW' | translate }}</p>
      </div>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'MESSAGES.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>